import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\NewModel\GetNewModelController::__invoke
* @see app/Http/Controllers/NewModel/GetNewModelController.php
* @route '/api/model/new'
*/
const GetNewModelController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewModelController.url(options),
    method: 'get',
})

GetNewModelController.definition = {
    methods: ["get","head"],
    url: '/api/model/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\NewModel\GetNewModelController::__invoke
* @see app/Http/Controllers/NewModel/GetNewModelController.php
* @route '/api/model/new'
*/
GetNewModelController.url = (options?: RouteQueryOptions) => {
    return GetNewModelController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NewModel\GetNewModelController::__invoke
* @see app/Http/Controllers/NewModel/GetNewModelController.php
* @route '/api/model/new'
*/
GetNewModelController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewModelController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NewModel\GetNewModelController::__invoke
* @see app/Http/Controllers/NewModel/GetNewModelController.php
* @route '/api/model/new'
*/
GetNewModelController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNewModelController.url(options),
    method: 'head',
})

export default GetNewModelController